import React from "react";
import { default as WInputLabel } from "@mui/material/InputLabel";

function InputLabel(props) {
  return <WInputLabel {...props} />;
}

export default InputLabel;
